<template>
	<div class="exam_box animate__animated animate__fadeIn">
		<div class="exam">
			<div class="title_box">
				<div class="text">{{ title }}</div>
			</div>
			<div class="search_box">
				<div class="box_line">
					<div class="line_input">
						<div class="input_title">试卷标题</div>
						<input type="text" class="input_box" placeholder="请输入试卷标题" v-model="form.title" />
					</div>
					<div class="line_input">
						<div class="input_title">考试类型</div>
                        <input type="text" class="input_box" placeholder="请输入考试类型" v-model="form.type" />
						<!-- <el-select size="small" class="select_box" v-model="form.type" :popper-append-to-body="false" filterable placeholder="请选择" style="border-radius: 0;">
							<el-option label="请选择" value></el-option>
							<el-option label="安全" value="1">安全</el-option>
							<el-option label="消防" value="2">消防</el-option>
						</el-select> -->
					</div>
					<div class="line_input desc">
						<div class="input_title">内容描述</div>
						<input type="text" class="input_box" placeholder="请输入考试内容描述" v-model="form.desc" />
					</div>
				</div>
			</div>
			<div v-if="selectList && selectList.length > 0">
				<div class="list_box" v-for="(item, index) in selectList" :key="index">
					<el-button @click="fnDelList(index)" style="float:right;margin-top:-20px" type="danger" icon="el-icon-delete" circle></el-button>
					<div class="box_title">
						<div class="title_txt">【{{ item.type }}】【{{ item.score }} 分】{{ parseInt(index) + 1 }}、{{ item.title }}</div>
						<img v-if="item.imgs" :src="item.imgs" />
					</div>
					<div class="box_answer">
						<div class="answer" v-for="(opt, idx) in item.answer" :key="idx">
							<div class="answer_txt" v-if="opt.answer_type == 't'">{{ fnChangeIndex(idx) }}、{{ opt.answer_text }}</div>
							<div class="answer_img" v-else>
								{{ fnChangeIndex(idx) }}、
								<img :src="opt.answer_text" />
							</div>
						</div>
						<div class="right_answer">【正确答案】{{ fnChangeAnswer(item.right_answer) }}</div>
					</div>
				</div>
			</div>
            <div class="sum_score">当前试卷总分数: {{ sumScore }} 分</div>
			<div class="add_box">
				<div class="search-btn red" @click="fnRefresh('/specialExam','7')"><span>返回</span></div>
				<div class="search-btn green" @click="isSetScore=true"><span>保存试卷</span></div>
				<div class="search-btn orange" @click="fnOpenAddOrEdit"><span>自主出题</span></div>
				<div class="search-btn" @click="fnOpenMineTest"><span>自有题库</span></div>
				<div class="search-btn" @click="fnOpenOtherTest"><span>公共题库</span></div>
			</div>
		</div>
		<!-- 自有题库 -->
		<div class="dialog_exam_mine" v-if="showMineTest">
			<el-dialog :custom-class="'animate__animated animate__fadeIn'" :modal="false" title="自有题库" center :visible.sync="showMineTest">
				<div class="exam_box">
					<div class="box_cont">
						<div class="mine_box">
							<div class="search_box mine_search">
								<div class="box_line mine_line">
									<div class="line_input">
										<div class="input_title">考试题目</div>
										<input type="text" class="input_box" placeholder="请输入考试题目" v-model="searchMineTitle" />
									</div>
									<div class="line_input">
										<div class="input_title">题目类型</div>
										<el-select size="small" class="select_box" v-model="searchMineType" :popper-append-to-body="false" filterable placeholder="请选择" style="border-radius: 0;">
											<el-option label="请选择" value></el-option>
											<el-option label="单选题" value="1">单项选择题</el-option>
											<el-option label="多选题" value="2">多项选择题</el-option>
											<el-option label="判断题" value="3">判断题</el-option>
										</el-select>
									</div>
								</div>
								<div class="box_line mine_line">
									<div class="line_input">
										<div class="input_title">创建时间</div>
										<el-date-picker
											size="small"
											v-model="searchMineCreateAt"
											type="datetimerange"
											value-format="yyyy-MM-dd HH:mm:ss"
											range-separator="至"
											start-placeholder="开始日期"
											end-placeholder="结束日期"
											style="width: 392px;"
										></el-date-picker>
									</div>
									<div class="search-btn" @click="fnSearchMineQuestionList"><span>搜索</span></div>
								</div>
							</div>
							<div class="cont_list">
								<div class="list_title">
									<div class="title_item"><div class="select" @click="fnSelectMineAll()" :class="selectMineAll ? 'active' : ''"></div></div>
									<div class="title_item">题目名称</div>
									<div class="title_item">题目类型</div>
									<div class="title_item">创建时间</div>
									<div class="title_item">所属项目</div>
								</div>
								<div class="list_boxes_cont">
									<div class="list_box_cont">
										<div v-if="mineTkList && mineTkList.length > 0">
											<div class="box_line" v-for="(item, index) in mineTkList" :key="index">
												<div class="list_item"><div class="select" @click="fnHandleCheckedMineTkChange(index, item)" :class="item.selected ? 'active' : ''"></div></div>
												<div class="list_item" :title="item.title">{{ item.title }}</div>
												<div class="list_item">{{ item.type }}</div>
												<div class="list_item">{{ item.create_at }}</div>
												<div class="list_item">本项目</div>
											</div>
										</div>
									</div>
								</div>
							</div>
							<!-- <div class="tips">注意：每次只能选择一道题！</div> -->
							<div class="cont_page">
								<el-pagination
									background
									class="pagination"
									@size-change="handleMineSizeChange"
									@current-change="handleMineCurrentChange"
									:page-sizes="minePageSizes"
									:page-size="minePageSize"
									:current-page="mineCurrentPage"
									layout="total, sizes, prev, pager, next, jumper"
									:total="minePageTotal"
								/>
							</div>
						</div>
					</div>
				</div>
				<div slot="footer" class="dialog-footer">
					<div class="btn_line">
						<div class="search-btn red" @click="showMineTest = false"><span>取消</span></div>
						<div class="search-btn" @click="fnSaveMineTest"><span>保存</span></div>
					</div>
				</div>
			</el-dialog>
		</div>
		<!-- 公共题库 -->
		<div class="dialog_exam_other" v-if="showOtherTest">
			<el-dialog :custom-class="'animate__animated animate__fadeIn'" :modal="false" title="公共题库" center :visible.sync="showOtherTest">
				<div class="exam_box">
					<div class="box_cont">
						<div class="mine_box">
							<div class="search_box mine_search">
								<div class="box_line mine_line">
									<div class="line_input">
										<div class="input_title">考试题目</div>
										<input type="text" class="input_box" placeholder="请输入考试题目" v-model="searchOtherTitle" />
									</div>
									<div class="line_input">
										<div class="input_title">题目类型</div>
										<el-select size="small" class="select_box" v-model="searchOtherType" :popper-append-to-body="false" filterable placeholder="请选择" style="border-radius: 0;">
											<el-option label="请选择" value></el-option>
											<el-option label="单项选择题" value="1">单项选择题</el-option>
											<el-option label="多项选择题" value="2">多项选择题</el-option>
											<el-option label="判断题" value="3">判断题</el-option>
										</el-select>
									</div>
								</div>
								<div class="box_line mine_line">
									<div class="line_input">
										<div class="input_title">创建时间</div>
										<el-date-picker
											size="small"
											v-model="searchOtherCreateAt"
											type="datetimerange"
											value-format="yyyy-MM-dd HH:mm:ss"
											range-separator="至"
											start-placeholder="开始日期"
											end-placeholder="结束日期"
											style="width: 392px;"
										></el-date-picker>
									</div>
									<div class="search-btn" @click="fnSearchOtherQuestionList"><span>搜索</span></div>
								</div>
							</div>
							<div class="cont_list">
								<div class="list_title">
									<div class="title_item"><div class="select" @click="fnSelectOtherAll()" :class="selectOtherAll ? 'active' : ''"></div></div>
									<div class="title_item">题目名称</div>
									<div class="title_item">题目类型</div>
									<div class="title_item">创建时间</div>
									<div class="title_item">所属项目</div>
								</div>
								<div class="list_boxes_cont">
									<div class="list_box_cont">
										<div v-if="otherTkList && otherTkList.length > 0">
											<div class="box_line" v-for="(item, index) in otherTkList" :key="index">
												<div class="list_item"><div class="select" @click="fnHandleCheckedOtherTkChange(index, item)" :class="item.selected ? 'active' : ''"></div></div>
												<div class="list_item" :title="item.title">{{ item.title }}</div>
												<div class="list_item">{{ item.type }}</div>
												<div class="list_item">{{ item.create_at }}</div>
												<div class="list_item" :title="item.from_name">{{ item.from_name }}</div>
											</div>
										</div>
									</div>
								</div>
							</div>
							<!-- <div class="tips">注意：每次只能选择一道题！</div> -->
							<div class="cont_page">
								<el-pagination
									background
									class="pagination"
									@size-change="handleOtherSizeChange"
									@current-change="handleOtherCurrentChange"
									:page-sizes="otherPageSizes"
									:page-size="otherPageSize"
									:current-page="otherCurrentPage"
									layout="total, sizes, prev, pager, next, jumper"
									:total="otherPageTotal"
								/>
							</div>
						</div>
					</div>
				</div>
				<div slot="footer" class="dialog-footer">
					<div class="btn_line">
						<div class="search-btn red" @click="showOtherTest = false"><span>取消</span></div>
						<div class="search-btn" @click="fnSaveOtherTest"><span>保存</span></div>
					</div>
				</div>
			</el-dialog>
		</div>
		<!-- 自主出题 -->
		<div class="dialog_test" v-if="showAddTest">
			<el-dialog :custom-class="'animate__animated animate__fadeIn'" :modal="false" title="新增/编辑试题" top="20vh" center :visible.sync="showAddTest">
				<div class="test_boxes">
					<div class="test_cont">
						<div class="test_item">
							<div class="item_title">试题名称</div>
							<div class="item_text">
								<input type="text" class="input_box" placeholder="请输入试题名称" v-model="addForm.title" />
							</div>
						</div>
						<div class="test_item">
							<div class="item_title">试题图片</div>
							<div class="item_imgs">
								<el-upload
									class="avatar-uploader"
									action=""
									list-type="picture-card"
									:before-upload="
										res => {
											beforeCardPicUpload(res, 'photo');
										}
									"
									:show-file-list="false"
								>
									<img v-if="addForm.imgs" :src="addForm.imgs" class="avatar" />
									<i v-else class="el-icon-plus avatar-uploader-icon"></i>
								</el-upload>
								<div class="search-btn" @click="fnClearImg('photo')"><span>清空图片</span></div>
							</div>
						</div>
						<div class="test_item">
							<div class="item_title">试题类型</div>
							<div class="item_text select">
								<el-select size="small" class="select_box" v-model="addForm.type" :popper-append-to-body="false" filterable placeholder="请选择" style="border-radius: 0;">
									<el-option label="请选择" value></el-option>
									<el-option label="单项选择题" value="1">单项选择题</el-option>
									<el-option label="多项选择题" value="2">多项选择题</el-option>
									<el-option label="判断题" value="3">判断题</el-option>
								</el-select>
							</div>
						</div>
						<div class="test_item">
							<div class="item_title">试题分数</div>
							<div class="item_text select">
								<el-select size="small" class="select_box" v-model="addForm.score" :popper-append-to-body="false" filterable placeholder="请选择" style="border-radius: 0;">
									<el-option label="请选择" value></el-option>
									<el-option label="1分" value="1">1分</el-option>
									<el-option label="2分" value="2">2分</el-option>
									<el-option label="3分" value="3">3分</el-option>
									<el-option label="5分" value="5">5分</el-option>
									<el-option label="10分" value="10">10分</el-option>
								</el-select>
							</div>
						</div>
						<div class="test_item">
							<div class="item_title">是否共享</div>
							<div class="item_text no-bg">
								<el-radio-group v-model="addForm.is_visible">
									<el-radio label="1">共享</el-radio>
									<el-radio label="0">不共享</el-radio>
								</el-radio-group>
							</div>
						</div>
						<div class="test_item">
							<div class="item_title">答案类型</div>
							<div class="item_text no-bg">
								<el-radio-group v-model="answerType" @change="fnAnswerTypeChange">
									<el-radio label="t">文字</el-radio>
									<el-radio label="i">图片</el-radio>
								</el-radio-group>
							</div>
						</div>
						<div class="test_item" v-if="rightAnswerList.length>0">
							<div class="item_title">正确答案</div>
							<div class="item_text no-bg">
								<el-checkbox-group v-model="rightAnswer" @change="handleCheckedAnswerChange">
									<el-checkbox v-for="(item,index) in rightAnswerList" :label="index" :key="index">{{item}}</el-checkbox>
								</el-checkbox-group>
							</div>
						</div>
						<div v-if="answerType=='t'">
							<div class="test_item" v-for="(item,index) in answerLists" :key="index">
								<div class="item_title">试题答案{{ parseInt(index)+1 }}</div>
								<div class="item_text">
									<input type="text" class="input_box" placeholder="请输入答案" v-model="item.text" />
								</div>
							</div>
						</div>
						<div v-else>
							<div class="test_item" v-for="(item,index) in answerLists" :key="index">
								<div class="item_title">试题答案{{ parseInt(index)+1 }}</div>
								<div class="item_imgs">
									<el-upload
										class="avatar-uploader"
										action=""
										list-type="picture-card"
										:before-upload="
											res => {
												beforeCardPicUpload(res, 'answer',index);
											}
										"
										:show-file-list="false"
									>
										<img v-if="item.text" :src="item.text" class="avatar" />
										<i v-else class="el-icon-plus avatar-uploader-icon"></i>
									</el-upload>
									<div class="search-btn" @click="fnClearImg('answer',index)"><span>清空图片</span></div>
								</div>
							</div>
						</div>
						<div class="test_item">
							<div class="search-btn" @click="fnAddTestAnswer"><span>新增试题答案</span></div>
						</div>
					</div>
				</div>
				<div slot="footer" class="dialog-footer" align="center">
					<div class="btn_line">
						<div class="search-btn red" @click="showAddTest = false"><span>取消</span></div>
						<div class="search-btn" @click="fnSaveAddOrEdit"><span>保存</span></div>
					</div>
				</div>
			</el-dialog>
		</div>
        <!-- 设置分数 -->
        <div class="dialog_score" v-if="isSetScore">
            <el-dialog :custom-class="'animate__animated animate__fadeIn'" :modal="false" title="分数设置" :visible.sync="isSetScore" center>
                <div class="test_item">当前试卷总分数为: {{ sumScore }} 分,请设置合格分数</div>
                <div class="test_item">
                	<div class="item_title">合格分数</div>
                	<div class="item_text">
                		<input type="text" class="input_box" placeholder="请输入合格分数" v-model="passScore"/>
                	</div>
                </div>
                <div slot="footer" class="dialog-footer">
                    <div class="btn_line">
                        <div class="search-btn red" @click="isSetScore=false"><span>取消</span></div>
                        <div class="search-btn" @click="fnSaveTest"><span>确定</span></div>
                    </div>
                </div>
            </el-dialog>
        </div>
	</div>
</template>

<script>
import APP from '@/utils/base';
import request from '@/utils/request';
import { getActiveIndex, setActiveIndex } from '@/utils/auth.js';
import store from '../../../store';
import { fnUpload } from '@/utils/upload';
import * as imageConversion from 'image-conversion';
export default {
	data() {
		return {
			id: null,
			title: '新增考试试卷',
            selectMineAll: false,
            selectOtherAll: false,
            selectQuesId: '',// 已选试题id
            isSetScore: false,
			// 自有试题分页
			minePageSize: APP.PAGE.LIMIT,
			minePageSizes: APP.PAGE.SIZE_OPTION,
			mineCurrentPage: APP.PAGE.SKIP_PAGE,
			minePageTotal: 0,
			// 公共试题分页
			otherPageSize: APP.PAGE.LIMIT,
			otherPageSizes: APP.PAGE.SIZE_OPTION,
			otherCurrentPage: APP.PAGE.SKIP_PAGE,
			otherPageTotal: 0,
			// 弹窗
			showMineTest: false, // 自有题库弹窗
			showOtherTest: false, // 公共题库弹窗
			// 试题列表
			mineTkList: [], // 自有题库试题列表
			// mineTkListAll: [], // 自有题库试题列表 固定
			otherTkList: [], // 公共题库试题列表
			otherTkListAll: [], // 公共题库试题列表 固定
			// 搜索
			searchMineTitle: '', // 自有题库考试题目搜索
			searchMineType: '', // 自有题库考试类型搜索
			searchMineCreateAt: '', // 自有题库创建时间搜索
			searchMineTime: '', // 自有题库创建时间 - 格式化
			searchOtherTitle: '', // 自有题库考试题目搜索
			searchOtherType: '', // 自有题库考试类型搜索
			searchOtherCreateAt: '', // 自有题库创建时间搜索
			searchOtherTime: '', // 自有题库创建时间 - 格式化
			// 待提交的数据
			form: {
				title: '',
				type: '',
				desc: '',
				ques_id: ''
			},
			selectList: [] ,// 选中的试题题目
			mineSelect: null,// 选择的自有试题
			otherSelect: null,// 选择的公共试题

			// 弹窗
			showAddTest: false,// 新增试题弹窗
			formLabelWidth: '120px', // 弹窗label宽度
			// 新增试题
			addForm:{
				title: '',// 试题题目
				imgs: '',// 题目里的图片
				type: '',// 考试类型
				answer: '',// 试题全部答案
				score: '',// 试题分数
				right_answer: '',// 试题正确答案
				is_visible: '1',// 是否共享
			},
			answerType: 't',//t->答案是文字类型 i->答案是图片类型
			answerForm:{
				text: ''
			},
			answerLists: [],
			rightAnswerList: [],
			rightAnswer: [],
            passScore: '',
		};
	},
	created() {
		// this.fnInit();
		let _id = this.$route.params.id;
		if(_id>0){
			this.id = _id;
			this.title = '编辑试题试卷';
			this.fnGetEditInfo(_id)
		}
		this.fnGetMineQuestionList();
		this.fnGetOtherQuestionList();
	},
    computed:{
        sumScore: function(){
            let _sum = 0
            for(let i in this.selectList){
                _sum+= parseInt(this.selectList[i].score)
            }
            return _sum
        }
    },
	methods: {
		// 路由跳转
		fnRefresh(_url, _activeIndex) {
			setActiveIndex(_activeIndex);
			store.dispatch('ChangeIndex', _activeIndex);
			if (_url === this.$route.path) {
				this.$router.push({
					path: '/redirect',
					query: _url
				});
			} else {
				this.$router.push({
					path: _url
				});
			}
		},
		// 获取编辑详情
		fnGetEditInfo(_id){
			request({
				url: 'exam/tk/allQues',
				method: 'GET',
				params: {tk_id:_id}
			})
				.then(res => {
					if(res.code == 1){
						let _data = res.data
						this.form.title = _data.title
						this.form.type = ''+_data.type
						this.form.desc = _data.desc
						let _list = _data.lists
						for(let i in _list){
							let _answer = _list[i].answer?JSON.parse(_list[i].answer):[]
							let _answerList = []
							for(let j in _answer){
								let _ob = {
									answer_type : _answer[j].split('|')[0],
									answer_text : _answer[j].split('|')[1]
								}
								_answerList.push(_ob)
							}
							_list[i].answer = _answerList
						}
						this.selectList = _list
					}
				})
				.catch(err => {
					this.$message.error(err.data);
				});
		},
		// 转换数字标签为字母
		fnChangeIndex(index) {
			switch (parseInt(index)) {
				case 0:
					return 'A';
				case 1:
					return 'B';
				case 2:
					return 'C';
				case 3:
					return 'D';
				case 4:
					return 'E';
				default:
					break;
			}
		},
		// 正确答案格式化
		fnChangeAnswer(answer) {
			let _answer = answer.split(',');
			let _arr = [];
			for (let i in _answer) {
				_arr.push(this.fnChangeIndex(_answer[i]));
			}
			return _arr.join(',');
		},
		// 删除试题
		fnDelList(index) {
			this.selectList.splice(index,1)
		},
		// 分页选择 自有考试试题
		handleMineSizeChange(val) {
			this.minePageSize = val;
			this.fnSearchMineQuestionList();
		},
		// 分页跳转 自有考试试题
		handleMineCurrentChange(val) {
			this.mineCurrentPage = val;
			this.fnSearchMineQuestionList();
		},
		// 分页选择 公共考试试题
		handleOtherSizeChange(val) {
			this.otherPageSize = val;
			this.fnSearchOtherQuestionList();
		},
		// 分页跳转 公共考试试题
		handleOtherCurrentChange(val) {
			this.otherCurrentPage = val;
			this.fnSearchOtherQuestionList();
		},
		// 获取自有考试试题列表
		fnGetMineQuestionList() {
			let _obj = {
				page: this.mineCurrentPage,
				size: this.minePageSize,
			};
            if(this.selectQuesId){
                _obj.ques_id = this.selectQuesId
            }
			request({
				url: 'exam/question/lists',
				method: 'GET',
				params: _obj
			})
				.then(res => {
					let _data = res.data.query;
					this.mineTkList = [];
					// this.mineTkListAll = []
					if (_data.length > 0) {
						for (let i in _data) {
							_data[i].selected = false;
						}
						this.mineTkList = _data;
						// this.mineTkListAll = _data
					}
					this.minePageTotal = res.data.count;
				})
				.catch(err => {
					this.$message.error(err.data);
				});
		},
		// 搜索自有考试试题列表
		fnSearchMineQuestionList(_isInit) {
			if (this.searchMineCreateAt) {
				this.searchMineTime = this.searchMineCreateAt[0] + ',' + this.searchMineCreateAt[1];
			} else {
				this.searchMineTime = '';
			}
			let _obj = {
				page: _isInit ? 1 : this.mineCurrentPage,
				size: this.minePageSize,
				title: this.searchMineTitle,
				type: this.searchMineType,
				create_at: this.searchMineTime,
			};
            if(this.selectQuesId){
                _obj.ques_id = this.selectQuesId
            }
			request({
				url: 'exam/question/lists',
				method: 'GET',
				params: _obj
			})
				.then(res => {
					let _data = res.data.query;
					this.mineTkList = [];
					// this.mineTkListAll = []
					if (_data.length > 0) {
						for (let i in _data) {
							_data[i].selected = false;
						}
						this.mineTkList = _data;
						// this.mineTkListAll = _data
					}
					this.minePageTotal = res.data.count;
				})
				.catch(err => {
					this.$message.error(err.data);
				});
		},
		// 获取公共考试试题列表
		fnGetOtherQuestionList() {
			let _obj = {
				page: this.otherCurrentPage,
				size: this.otherPageSize
			};
			request({
				url: 'exam/question/otherLists',
				method: 'GET',
				params: _obj
			})
				.then(res => {
					let _data = res.data.query;
					this.otherTkList = [];
					this.otherTkListAll = [];
					if (_data.length > 0) {
						for (let i in _data) {
							_data[i].selected = false;
						}
						this.otherTkList = _data;
						this.otherTkListAll = _data
					}
					this.otherPageTotal = res.data.count;
				})
				.catch(err => {
					this.$message.error(err.data);
				});
		},
		// 搜索公共考试试题列表
		fnSearchOtherQuestionList(_isInit) {
			if (this.searchOtherCreateAt) {
				this.searchOtherTime = this.searchOtherCreateAt[0] + ',' + this.searchOtherCreateAt[1];
			} else {
				this.searchOtherTime = '';
			}
			let _obj = {
				page: _isInit ? 1 : this.otherCurrentPage,
				size: this.otherPageSize,
				title: this.searchOtherTitle,
				type: this.searchOtherType,
				create_at: this.searchOtherTime
			};
			request({
				url: 'exam/question/otherLists',
				method: 'GET',
				params: _obj
			})
				.then(res => {
					let _data = res.data.query;
					this.otherTkList = [];
					this.otherTkListAll = [];
					if (_data.length > 0) {
						for (let i in _data) {
							_data[i].selected = false;
						}
						this.otherTkList = _data;
						this.otherTkListAll = _data;
					}
					this.otherPageTotal = res.data.count;
				})
				.catch(err => {
					this.$message.error(err.data);
				});
		},
		// 打开自有题库弹窗
		fnOpenMineTest(){
			// this.mineTkList = JSON.parse(JSON.stringify(this.mineTkListAll))
            let _arr = []
            for(let i in this.selectList){
                _arr.push(this.selectList[i].id)
            }
            this.selectQuesId = _arr.join(',')
            this.fnGetMineQuestionList()
            this.$nextTick(()=>{
                this.selectOtherAll = false
                this.showMineTest = true
            })
		},
		// 打开公共题库弹窗
		fnOpenOtherTest(){
			this.otherTkList = JSON.parse(JSON.stringify(this.otherTkListAll))
			this.showOtherTest = true
		},
        // 全选 自有题库
        fnSelectMineAll(){
            this.selectMineAll = !this.selectMineAll;
            if (this.selectMineAll) {
            	for (let i = 0; i < this.mineTkList.length; i++) {
            		this.mineTkList[i].selected = true;
            	}
            	this.mineSelect = this.mineTkList;
            } else {
            	for (let i = 0; i < this.mineTkList.length; i++) {
            		this.mineTkList[i].selected = false;
            		this.mineSelect = [];
            	}
            }
        },
		// 多选 自有题库
		fnHandleCheckedMineTkChange(_index,_item) {
            for(let i=0;i<this.mineTkList.length;i++){
                if (i == _index) {
                	this.mineTkList[i].selected = !this.mineTkList[i].selected;
                }
            }
            let _arr = [];
            for (let j = 0; j < this.mineTkList.length; j++) {
            	if (this.mineTkList[j].selected) {
            		_arr.push(this.mineTkList[j]);
            	}
            }
            if (_arr.length == this.mineTkList.length) {
            	this.selectMineAll = true;
            } else {
            	this.selectMineAll = false;
            }
            this.mineSelect = _arr;
		},
        // 全选 公共题库
        fnSelectOtherAll(){
           this.selectOtherAll = !this.selectOtherAll;
           if (this.selectOtherAll) {
           	for (let i = 0; i < this.otherTkList.length; i++) {
           		this.otherTkList[i].selected = true;
           	}
           	this.otherSelect = this.otherTkList;
           } else {
           	for (let i = 0; i < this.otherTkList.length; i++) {
           		this.otherTkList[i].selected = false;
           		this.otherSelect = [];
           	}
           }
        },
		// 多选 公共题库
		fnHandleCheckedOtherTkChange(_index,_item){
            for(let i=0;i<this.otherTkList.length;i++){
                if (i == _index) {
                	this.otherTkList[i].selected = !this.otherTkList[i].selected;
                }
            }
            let _arr = [];
            for (let j = 0; j < this.otherTkList.length; j++) {
            	if (this.otherTkList[j].selected) {
            		_arr.push(this.otherTkList[j]);
            	}
            }
            if (_arr.length == this.otherTkList.length) {
            	this.selectOtherAll = true;
            } else {
            	this.selectOtherAll = false;
            }
            this.otherSelect = _arr;
		},
		// 保存选择的自有题库试题
		fnSaveMineTest() {
			if(this.mineSelect&&this.mineSelect.length>0){
                for(let i in this.mineSelect){
                    let _obj = this.mineSelect[i]
                    let _answer = _obj.answer?JSON.parse(_obj.answer):[]
                    let _answerList = []
                    for(let j in _answer){
                        let _ob = {
                            answer_type : _answer[j].split('|')[0],
                            answer_text : _answer[j].split('|')[1]
                        }
                        _answerList.push(_ob)
                    }
                    _obj.answer = _answerList
                    this.selectList.push(_obj)
                }
				this.showMineTest = false
			}else{
				this.$message.warning("您还没有选择试题哦！")
			}
		},
		// 保存选择的公共题库试题
		fnSaveOtherTest() {
			if(this.otherSelect&&this.otherSelect.length>0){
                for(let i in this.otherSelect){
                    let _obj = this.otherSelect[i]
                    request({
                        url: 'exam/tk/addQues',
                        method: 'POST',
                        data: {id: _obj.id}
                    })
                        .then(res => {
                            if (res.code == 1) {
                                let _id = parseInt(res.data)
                                _obj.id = _id
                                let _answer = _obj.answer?JSON.parse(_obj.answer):[]
                                let _answerList = []
                                for(let j in _answer){
                                    let _ob = {
                                        answer_type : _answer[j].split('|')[0],
                                        answer_text : _answer[j].split('|')[1]
                                    }
                                    _answerList.push(_ob)
                                }
                                _obj.answer = _answerList
                                this.selectList.push(_obj)
                            }
                        })
                        .catch(err => {
                            this.$message.error(err.data);
                        });
                }
                 this.showOtherTest = false
			}else{
				this.$message.warning("您还没有选择试题哦！")
			}
		},
		// 保存提交试题
		fnSaveTest(){
            let reg = /^\d+$|^\d+[.]?\d+$/
            if(!reg.test(this.passScore)){
                this.$message.warning("输入的合格分数只能是数字！")
                return
            }
			let _arr = []
			for(let i in this.selectList){
				_arr.push(this.selectList[i].id)
			}
			if(_arr.length == 0){
				return this.$message.warning("您还没有选择试题！")
			}else{
				this.form.ques_id = _arr.join(',')
			}
			if(this.form.title == ''){
				return this.$message.warning("请输入试卷标题！")
			}
			if(this.form.type == ''){
				return this.$message.warning("请输入考试类型！")
			}
            if(this.form.type.length>4){
                return this.$message.warning("输入的考试类型不能超过4个字!")
            }
			if(this.form.desc == ''){
				return this.$message.warning("请输入考试内容描述！")
			}
			let _url = ''
			if(this.id>0){
				this.form.id = this.id
                this.form.pass = this.passScore
				_url = 'exam/tk/edit'
			}else{
                this.form.pass = this.passScore
				_url = 'exam/tk/add'
			}
			request({
				url: _url,
				method: 'POST',
				data: this.form
			})
				.then(res => {
					this.$message.success(res.data)
					setTimeout(()=>{
						this.fnRefresh('/specialExam','7')
					},1000)
				})
				.catch(err => {
					this.$message.error(err.data);
				});

		},
		// 打开新增/编辑试题弹窗
		fnOpenAddOrEdit(){
			this.addForm.title = ''
			this.addForm.imgs = ''
			this.addForm.type = ''
			this.addForm.answer = ''
			this.addForm.score = ''
			this.addForm.right_answer = ''
			this.answerLists = []
			this.rightAnswerList = []
			this.answerType = 't'
			this.showAddTest = true
		},
		// 上传图片
		beforeCardPicUpload(_file, _el, _index) {
			let that = this;
			// 把图片文件压缩到200kb
			imageConversion.compressAccurately(_file, 200).then(_res => {
				let reader = new FileReader();
				reader.onload = function() {
					let _base64 = this.result;
					// base64转文件流对象
					let _fileObject = APP.fnBase64ToFile(_base64);
					let formData = new FormData();
					formData.append('file', _fileObject);
					formData.append('type', 'image');
					if (_base64.indexOf('data:image/') != -1) {
						_base64 = _base64.split(',')[1];
					}
					fnUpload(formData, res => {
						if(_el == 'photo'){
							that.addForm.imgs = res.data.file_url
						}else{
							that.answerLists[_index].text = res.data.file_url
						}
					});
				};
				reader.readAsDataURL(_res);
			});
			return false; // 阻止组件自动上传图片
		},
		// 清空上传的图片
		fnClearImg(type,index){
			if(type == 'photo'){
				this.addForm.imgs = ''
			}else{
				this.answerLists[index].text = ''
			}
		},
		// 答案类型改变
		fnAnswerTypeChange(e){
			this.answerType = e
			this.answerLists = []
			this.rightAnswerList = []
			this.rightAnswer = []
		},
		// 选择切换正确答案
		handleCheckedAnswerChange(value){
			this.rightAnswer = value
		},
		// 新增考试答案
		fnAddTestAnswer(){
			let _obj = JSON.parse(JSON.stringify(this.answerForm))
			this.answerLists.push(_obj)
			let _index = this.answerLists.length
			this.rightAnswerList.push('答案'+_index)
		},
		// 保存 新增/编辑 试题
		fnSaveAddOrEdit(){
			if(this.addForm.title==''){
				return this.$message.warning('您的试题名称不能为空!')
			}
			if(this.addForm.type == ''){
				return this.$message.warning('您的试题类型不能为空!')
			}
			if(this.addForm.score == ''){
				return this.$message.warning('请选择您的试题分数!')
			}
			let _type = this.answerType + '|'
			let _arr = []
			if(this.answerLists.length>0){
				for(let i in this.answerLists){
					if(this.answerLists[i].text == ''){
						return this.$message.warning('请输入试题答案' + (parseInt(i)+1) + '的内容')
					}else{
						_arr.push(_type + this.answerLists[i].text)
					}
				}
				this.addForm.answer = JSON.stringify(_arr)
			}else{
				return this.$message.warning('请新增试题答案!')
			}
			if(this.rightAnswer.length>0){
				if(this.addForm.type == 1||this.addForm.type == 3){
					if(this.rightAnswer.length>1){
						return this.$message.warning('您的试题只能选择一个正确答案!')
					}
				}
				this.addForm.right_answer = this.rightAnswer.join(',')
			}else{
				return this.$message.warning('请勾选您试题的正确答案!')
			}
			request({
				url: 'exam/tk/addQues',
				method: 'POST',
				data: this.addForm
			})
				.then(res => {
					if(res.code == 1){
						let _test = JSON.parse(JSON.stringify(this.addForm))
						_test.id = parseInt(res.data)
						let _obj = _test
						let _answer = _obj.answer?JSON.parse(_obj.answer):[]
						let _answerList = []
						for(let j in _answer){
							let _ob = {
								answer_type : _answer[j].split('|')[0],
								answer_text : _answer[j].split('|')[1]
							}
							_answerList.push(_ob)
						}
						_obj.answer = _answerList
						_obj.type = _obj.type=='1'?'单项选择题':_obj.type=='2'?'多项选择题':'判断题'
						this.selectList.push(_obj)
					}else{
						this.$message.error(res.data)
					}
					this.showAddTest = false
				})
				.catch(err => {
					this.$message.error(err.data);
				});
		},
	}
};
</script>

<style lang="scss" scoped>
@import '~@/styles/mixin.scss';
.exam_box {
	width: 1920px;
	height: 858px;
	position: relative;
	overflow: hidden;
	.exam {
		position: absolute;
		left: 0;
		right: -20px;
		top: 0;
		bottom: 0;
		overflow-x: hidden;
		overflow-y: auto;
	}
}
.title_box {
	width: 1880px;
	height: 50px;
	margin-top: 24px;
	margin-left: 20px;
	text-align: center;
	font-size: 34px;
}
.search_box {
	height: 40px;
	width: 1880px;
	margin-top: 10px;
	margin-left: 20px;
	@include flex-box(space-between, center, column);
	&.mine_search {
		width: 860px;
		height: 74px;
		margin: 0 0 10px;
	}
	.box_line {
		width: 1880px;
		height: 40px;
		@include flex-box(flex-start, center);
		.line_input {
			min-width: 410px;
			height: 40px;
			margin-right: 10px;
			border-top-right-radius: 1px;
			border-bottom-right-radius: 1px;
			background-color: rgba(49, 88, 128, 0.4);
			@include flex-box(flex-start, center);
			.input_title {
				width: 90px;
				height: 40px;
				font-size: 16px;
				padding: 0 10px;
				color: #9bf9fc;
				border-radius: 2px;
				background-color: rgba(155, 249, 252, 0.1);
				@include flex-box(center, center);
			}
			.input_box {
				width: 320px;
				height: 40px;
				line-height: 40px;
				padding-left: 15px;
				color: rgba(77, 180, 244, 0.7);
				font-size: 12px;
				border-radius: 2px;
				outline: none;
				background: transparent;
				border: none;
				&::-webkit-input-placeholder {
					color: rgba(77, 180, 244, 0.7);
				}
				&::-moz-placeholder {
					/* Mozilla Firefox 19+ */
					color: rgba(77, 180, 244, 0.7);
				}
				&:-moz-placeholder {
					/* Mozilla Firefox 4 to 18 */
					color: rgba(77, 180, 244, 0.7);
				}
				&:-ms-input-placeholder {
					/* Internet Explorer 10-11 */
					color: rgba(77, 180, 244, 0.7);
				}
			}
			.select_box {
				width: 320px;
				height: 40px;
				border-radius: 2px;
			}
			>>> .el-input__inner {
				width: 320px;
				height: 40px;
				border-radius: 2px;
				border: none;
				color: rgba(77, 180, 244, 0.7);
				background: transparent;
				&::-webkit-input-placeholder {
					color: rgba(77, 180, 244, 0.7);
				}
				&::-moz-placeholder {
					/* Mozilla Firefox 19+ */
					color: rgba(77, 180, 244, 0.7);
				}
				&:-moz-placeholder {
					/* Mozilla Firefox 4 to 18 */
					color: rgba(77, 180, 244, 0.7);
				}
				&:-ms-input-placeholder {
					/* Internet Explorer 10-11 */
					color: rgba(77, 180, 244, 0.7);
				}
			}
			>>> .el-select__caret {
				color: rgba(77, 180, 244, 0.7);
			}
			>>> .el-select-dropdown {
				background-color: rgba(9, 17, 32, 1);
				border: 1px solid rgba(77, 180, 244, 1);
			}
			>>> .popper__arrow {
				border-bottom-color: rgba(77, 180, 244, 1) !important;
			}
			>>> .el-select-dropdown__item {
				color: rgba(77, 180, 244, 0.7);
			}
			>>> .el-select-dropdown__item:hover {
				color: #409eff;
			}
			>>> .el-select-dropdown__item.hover {
				color: #409eff;
			}
			>>> .el-input__icon {
				color: rgba(77, 180, 244, 0.7);
			}
			>>> .el-range-input {
				color: rgba(77, 180, 244, 0.7);
				background: transparent;
				&::-webkit-input-placeholder {
					color: rgba(77, 180, 244, 0.7);
				}
				&::-moz-placeholder {
					/* Mozilla Firefox 19+ */
					color: rgba(77, 180, 244, 0.7);
				}
				&:-moz-placeholder {
					/* Mozilla Firefox 4 to 18 */
					color: rgba(77, 180, 244, 0.7);
				}
				&:-ms-input-placeholder {
					/* Internet Explorer 10-11 */
					color: rgba(77, 180, 244, 0.7);
				}
			}
			&.desc {
				.input_box {
					width: 740px;
				}
				>>> .el-input__inner {
					width: 740px !important;
				}
			}
		}
		&.mine_line {
			height: 32px;
			width: 860px;
			.line_input {
				height: 32px;
				.input_title {
					height: 32px;
				}
				.input_box {
					height: 32px;
				}
			}
		}
	}
}
.sum_score{
    width: 1880px;
    height: 36px;
    line-height: 36px;
    margin-top: 10px;
    margin-left: 20px;
}
.add_box {
	width: 1880px;
	height: 36px;
	margin-top: 20px;
	margin-left: 20px;
	text-align: right;
	font-size: 34px;
	@include flex-box(flex-end, center);
}
.list_box {
	width: 1880px;
	min-height: 100px;
	margin: 20px 20px 0;
	padding: 10px 20px;
	border-radius: 5px;
	border: 1px dashed #1d4495;
	.box_title {
		width: 1840px;
		min-height: 30px;
		.title_txt {
			width: 100%;
			height: 30px;
			line-height: 30px;
			font-size: 16px;
		}
		img {
			margin: 10px 0;
			width: 240px;
			height: 180px;
			border-radius: 3px;
		}
	}
	.box_answer {
		width: 1840px;
		min-height: 30px;
		.answer {
			width: 100%;
			min-height: 30px;
			.answer_txt {
				width: 100%;
				min-height: 30px;
				line-height: 30px;
				font-size: 12px;
			}
			.answer_img {
				@include flex-box(flex-start);
				img {
					margin: 10px 0;
					width: 200px;
					height: 160px;
					border-radius: 3px;
				}
			}
		}
	}
}
.dialog_exam_mine,
.dialog_exam_other {
	>>> .el-dialog {
		width: 910px;
		margin-top: 20vh !important;
		background-color: rgba(9, 17, 32, 1);
		border: 1px solid #3a74dd;
	}
	>>> .el-form-item__label {
		color: #4db4f4;
	}
	>>> .el-dialog__title {
		color: #4db4f4;
	}
	.exam_box {
		width: 860px;
		height: 470px;
		color: #ffffff;
		font-size: 16px;
		position: relative;
		overflow: hidden;
		.box_cont {
			position: absolute;
			left: 0;
			right: -25px;
			top: 0;
			bottom: 0;
			overflow-x: hidden;
			overflow-y: auto;
		}
		.cont_list {
			width: 860px;
			height: 350px;
			color: #ffffff;
			font-size: 16px;
			border-radius: 10px;
			margin: 0;
			background-color: rgba(29, 68, 149, 0.1);
			.list_title {
				width: 860px;
				height: 48px;
				background: url(../../../assets/img/per_list_bg.png) no-repeat;
				background-size: 100% 100%;
				@include flex-box(flex-start, center);
				.title_item {
					height: 48px;
					@include flex-box(center, center);
					&:nth-child(1) {
						width: 61px;
						margin: 0 4px 0 30px;
					}
					&:nth-child(2) {
						width: 251px;
						margin-right: 4px;
					}
					&:nth-child(3) {
						width: 101px;
						margin-right: 4px;
					}
					&:nth-child(4) {
						width: 186px;
						margin-right: 4px;
					}
					&:nth-child(5) {
						width: 185px;
						margin-right: 30px;
					}
                    .select {
                    	width: 20px;
                    	height: 20px;
                    	border: 1px solid #65a6dd;
                    	border-radius: 2px;
                    	cursor: pointer;
                    	@include prefixCss3(transition, border-color 0.2s);
                    	&:hover {
                    		border-color: #409eff;
                    	}
                    	&.active {
                    		background-color: #409eff;
                    		border-color: #409eff;
                    		&::after {
                    			content: '';
                    			display: block;
                    			width: 100%;
                    			height: 100%;
                    			@include set-bg-img('../../../assets/images/icon-yes.png');
                    		}
                    	}
                    }
				}
			}
			.list_boxes_cont {
				width: 800px;
				height: 225px;
				margin-left: 30px;
				position: relative;
				overflow: hidden;
				.list_box_cont {
					position: absolute;
					left: 0;
					right: -25px;
					top: 0;
					bottom: 0;
					overflow-x: hidden;
					overflow-y: auto;
					.box_conts {
						width: 100%;
					}
					.box_line {
						width: 800px;
						height: 70px;
						margin: 5px 0 0 0px;
						border-bottom: 1px dashed #1d4495;
						@include flex-box(flex-start, center);
						&:hover {
							background-color: rgba(49, 88, 128, 0.4);
						}
						.list_item {
							height: 70px;
							text-align: center;
							@include flex-box(center, center);
							&:nth-child(1) {
								width: 61px;
								margin-right: 4px;
							}
							&:nth-child(2) {
								width: 251px;
								margin-right: 4px;
								cursor: pointer;
								overflow: hidden;
								text-overflow: ellipsis;
								white-space: nowrap;
							}
							&:nth-child(3) {
								width: 101px;
								margin-right: 4px;
							}
							&:nth-child(4) {
								width: 186px;
								margin-right: 4px;
							}
							&:nth-child(5) {
								width: 185px;
								cursor: pointer;
								overflow: hidden;
								text-overflow: ellipsis;
								white-space: nowrap;
							}
							div {
								@include flex-box(center, center);
							}
							.select {
								width: 20px;
								height: 20px;
								border: 1px solid #65a6dd;
								border-radius: 2px;
								cursor: pointer;
								@include prefixCss3(transition, border-color 0.2s);
								&:hover {
									border-color: #409eff;
								}
								&.active {
									background-color: #409eff;
									border-color: #409eff;
									&::after {
										content: '';
										display: block;
										width: 100%;
										height: 100%;
										@include set-bg-img('../../../assets/images/icon-yes.png');
									}
								}
							}
						}
					}
				}
			}
		}
		.tips{
			width: 840px;
			height: 30px;
			line-height: 30px;
			color: #FF4949;
		}
		.cont_page {
			width: 840px;
			height: 30px;
			>>> .el-pagination__total {
				color: #439fe3;
				font-size: 14px !important;
			}
			>>> .el-input__inner {
				background-color: rgba(49, 88, 128, 0.5) !important;
				border: none !important;
				color: #439fe3 !important;
			}
			>>> .el-pagination__jump {
				color: #439fe3;
				font-size: 14px !important;
			}
			>>> .el-select__caret {
				color: #439fe3;
			}
			>>> .el-pagination.is-background .btn-prev {
				color: #439fe3;
				background-color: rgba(49, 88, 128, 0.5) !important;
			}
			>>> .el-pagination.is-background .btn-prev:disabled {
				color: #439fe3;
				background-color: rgba(49, 88, 128, 0.5) !important;
			}
			>>> .el-pagination.is-background .btn-next {
				color: #439fe3;
				background-color: rgba(49, 88, 128, 0.5) !important;
			}
			>>> .el-pagination.is-background .btn-next:disabled {
				color: #439fe3;
				background-color: rgba(49, 88, 128, 0.5) !important;
			}
			>>> .el-pagination.is-background .el-pager li {
				color: #439fe3;
				background-color: rgba(49, 88, 128, 0.5) !important;
			}
			>>> .el-pagination.is-background .el-pager li:not(.disabled).active {
				background-color: #50aaff !important;
				color: #091027;
			}
		}
	}
	.btn_line {
		@include flex-box(center, center);
	}
}
.dialog_test{
	.btn_line {
		@include flex-box(center, center);
	}
	>>> .el-dialog {
		width: 910px;
		height: 610px;
		background-color: rgba(9, 17, 32, 1);
		border: 1px solid rgba(58, 116, 221, 1);
	}
	.test_boxes{
		width: 870px;
		height: 490px;
		position: relative;
		overflow: hidden;
		.test_cont {
			position: absolute;
			left: 0;
			right: -25px;
			top: 0;
			bottom: 0;
			overflow-x: hidden;
			overflow-y: auto;
		}
		.test_item{
			width: 870px;
			min-height: 30px;
			padding: 0 20px;
			margin: 10px 0;
			@include flex-box();
			.item_title{
				width: 100px;
				height: 30px;
				color: #9bf9fc;
				margin-right: 5px;
				background-color: rgba(49, 88, 128, 0.4);
				@include flex-box(center,center);
			}
			.item_text{
				width: 300px;
				height: 30px;
				border-top-right-radius: 1px;
				border-bottom-right-radius: 1px;
				background-color: rgba(49, 88, 128, 0.4);
				@include flex-box(flex-start, center);
				&.select{
					background: none;
				}
				&.no-bg{
					width: 600px;
					background: none;
				}
				.input_box {
					width: 300px;
					height: 30px;
					line-height: 30px;
					padding-left: 15px;
					color: rgba(77, 180, 244, 0.7);
					font-size: 12px;
					border-radius: 2px;
					outline: none;
					background: transparent;
					border: none;
					&::-webkit-input-placeholder {
						color: rgba(77, 180, 244, 0.7);
					}
					&::-moz-placeholder {
						/* Mozilla Firefox 19+ */
						color: rgba(77, 180, 244, 0.7);
					}
					&:-moz-placeholder {
						/* Mozilla Firefox 4 to 18 */
						color: rgba(77, 180, 244, 0.7);
					}
					&:-ms-input-placeholder {
						/* Internet Explorer 10-11 */
						color: rgba(77, 180, 244, 0.7);
					}
				}
				.select_box {
					width: 300px;
					height: 30px;
					border-radius: 2px;
				}
				>>> .el-input__inner {
					width: 300px;
					height: 30px;
					background-color: rgba(49, 88, 128, 0.5) !important;
					border: none !important;
					color: #439fe3 !important;
				}
				.el-select__caret {
					color: rgba(77, 180, 244, 0.7);
				}
				>>>.el-radio__label{
					color: #4DB4F4;
				}
				>>>.el-checkbox__label{
					color: #439fe3 !important;
				}
			}
			>>> .avatar-uploader {
				line-height: 100px;
				border-radius: 2px;
				img {
					width: 98px;
					height: 98px;
					border-radius: 2px;
				}
			}
			.item_imgs{
				width: 220px;
				height: 100px;
				@include flex-box(flex-start,flex-end);
				>>> .el-upload {
					width: 100px;
					height: 100px;
					line-height: 100px;
				}
				// 上传图片样式
				>>> .el-upload--picture-card {
					background-color: rgba(9, 17, 32, 0.5);
				}
			}
		}
	}
	>>>.el-dialog__body{
		padding: 0 20px;
	}
	>>> .el-form-item__label {
		color: #4db4f4;
	}
	>>> .el-dialog__title {
		color: #4db4f4;
	}
	>>> .el-dialog__close {
		color: #4db4f4;
	}
}
.dialog_exam_other {
	>>> .el-dialog {
		width: 910px;
		margin-top: 20vh !important;
		background-color: rgba(9, 17, 32, 1);
		border: 1px solid #3a74dd;
	}
	>>> .el-form-item__label {
		color: #4db4f4;
	}
	>>> .el-dialog__title {
		color: #4db4f4;
	}
	.exam_box {
		width: 860px;
		height: 500px;
		color: #ffffff;
		font-size: 16px;
		position: relative;
		overflow: hidden;
		.box_cont {
			position: absolute;
			left: 0;
			right: -25px;
			top: 0;
			bottom: 0;
			overflow-x: hidden;
			overflow-y: auto;
		}
		.cont_list {
			width: 860px;
			height: 350px;
			color: #ffffff;
			font-size: 16px;
			border-radius: 10px;
			margin: 0;
			background-color: rgba(29, 68, 149, 0.1);
			.list_title {
				width: 860px;
				height: 48px;
				background: url(../../../assets/img/per_list_bg.png) no-repeat;
				background-size: 100% 100%;
				@include flex-box(flex-start, center);
				.title_item {
					height: 48px;
					@include flex-box(center, center);
					&:nth-child(1) {
						width: 61px;
						margin: 0 4px 0 30px;
					}
					&:nth-child(2) {
						width: 251px;
						margin-right: 4px;
					}
					&:nth-child(3) {
						width: 101px;
						margin-right: 4px;
					}
					&:nth-child(4) {
						width: 186px;
						margin-right: 4px;
					}
					&:nth-child(5) {
						width: 185px;
						margin-right: 30px;
					}
				}
			}
			.list_boxes_cont {
				width: 800px;
				height: 225px;
				margin-left: 30px;
				position: relative;
				overflow: hidden;
				.list_box_cont {
					position: absolute;
					left: 0;
					right: -25px;
					top: 0;
					bottom: 0;
					overflow-x: hidden;
					overflow-y: auto;
					.box_conts {
						width: 100%;
					}
					.box_line {
						width: 800px;
						height: 70px;
						margin: 5px 0 0 0px;
						border-bottom: 1px dashed #1d4495;
						@include flex-box(flex-start, center);
						&:hover {
							background-color: rgba(49, 88, 128, 0.4);
						}
						.list_item {
							height: 70px;
							text-align: center;
							@include flex-box(center, center);
							&:nth-child(1) {
								width: 61px;
								margin-right: 4px;
							}
							&:nth-child(2) {
								width: 251px;
								margin-right: 4px;
								cursor: pointer;
								overflow: hidden;
								text-overflow: ellipsis;
								white-space: nowrap;
							}
							&:nth-child(3) {
								width: 101px;
								margin-right: 4px;
							}
							&:nth-child(4) {
								width: 186px;
								margin-right: 4px;
							}
							&:nth-child(5) {
								width: 185px;
								cursor: pointer;
								overflow: hidden;
								text-overflow: ellipsis;
								white-space: nowrap;
							}
							div {
								@include flex-box(center, center);
							}
							.select {
								width: 20px;
								height: 20px;
								border: 1px solid #65a6dd;
								border-radius: 2px;
								cursor: pointer;
								@include prefixCss3(transition, border-color 0.2s);
								&:hover {
									border-color: #409eff;
								}
								&.active {
									background-color: #409eff;
									border-color: #409eff;
									&::after {
										content: '';
										display: block;
										width: 100%;
										height: 100%;
										@include set-bg-img('../../../assets/images/icon-yes.png');
									}
								}
							}
						}
					}
				}
			}
		}
		.tips{
			width: 840px;
			height: 30px;
			line-height: 30px;
			color: #FF4949;
		}
		.other_page {
			width: 840px;
			height: 30px;
			>>> .el-pagination__total {
				color: #439fe3;
				font-size: 14px !important;
			}
			>>> .el-input__inner {
				background-color: rgba(49, 88, 128, 0.5) !important;
				border: none !important;
				color: #439fe3 !important;
			}
			>>> .el-pagination__jump {
				color: #439fe3;
				font-size: 14px !important;
			}
			>>> .el-select__caret {
				color: #439fe3;
			}
			>>> .el-pagination.is-background .btn-prev {
				color: #439fe3;
				background-color: rgba(49, 88, 128, 0.5) !important;
			}
			>>> .el-pagination.is-background .btn-prev:disabled {
				color: #439fe3;
				background-color: rgba(49, 88, 128, 0.5) !important;
			}
			>>> .el-pagination.is-background .btn-next {
				color: #439fe3;
				background-color: rgba(49, 88, 128, 0.5) !important;
			}
			>>> .el-pagination.is-background .btn-next:disabled {
				color: #439fe3;
				background-color: rgba(49, 88, 128, 0.5) !important;
			}
			>>> .el-pagination.is-background .el-pager li {
				color: #439fe3;
				background-color: rgba(49, 88, 128, 0.5) !important;
			}
			>>> .el-pagination.is-background .el-pager li:not(.disabled).active {
				background-color: #50aaff !important;
				color: #091027;
			}
		}
	}
	.btn_line {
		@include flex-box(center, center);
	}
}
.dialog_score{
	.btn_line{
		@include flex-box(center,center);
	}
	>>>.el-dialog{
		width: 500px;
		height: 230px;
		margin-top: 40vh!important;
		background-color: rgba(9, 17, 32, 1);
		border: 1px solid rgba(58,116,221,1);
	}
	>>>.el-form-item__label{
		color: #4DB4F4;
	}
    >>>.el-dialog__body{
        padding: 10px;
    }
	>>>.el-dialog__title{
		color: #4DB4F4;
	}
	>>>.el-dialog__close{
		color: #4DB4F4;
	}
    .test_item{
    	width: 500px;
    	min-height: 30px;
    	padding: 0 20px;
    	margin: 10px 0;
    	@include flex-box();
        color: #FFFFFF;

    	.item_title{
    		width: 100px;
    		height: 30px;
    		color: #9bf9fc;
    		margin-right: 5px;
    		background-color: rgba(49, 88, 128, 0.4);
    		@include flex-box(center,center);
    	}
    	.item_text{
    		width: 300px;
    		height: 30px;
    		border-top-right-radius: 1px;
    		border-bottom-right-radius: 1px;
    		background-color: rgba(49, 88, 128, 0.4);
    		@include flex-box(flex-start, center);

    		.input_box {
    			width: 300px;
    			height: 30px;
    			line-height: 30px;
    			padding-left: 15px;
    			color: rgba(77, 180, 244, 0.7);
    			font-size: 12px;
    			border-radius: 2px;
    			outline: none;
    			background: transparent;
    			border: none;
    			&::-webkit-input-placeholder {
    				color: rgba(77, 180, 244, 0.7);
    			}
    			&::-moz-placeholder {
    				/* Mozilla Firefox 19+ */
    				color: rgba(77, 180, 244, 0.7);
    			}
    			&:-moz-placeholder {
    				/* Mozilla Firefox 4 to 18 */
    				color: rgba(77, 180, 244, 0.7);
    			}
    			&:-ms-input-placeholder {
    				/* Internet Explorer 10-11 */
    				color: rgba(77, 180, 244, 0.7);
    			}
    		}

    		>>> .el-input__inner {
    			width: 300px;
    			height: 30px;
    			background-color: rgba(49, 88, 128, 0.5) !important;
    			border: none !important;
    			color: #439fe3 !important;
    		}
    		.el-select__caret {
    			color: rgba(77, 180, 244, 0.7);
    		}
    		>>>.el-radio__label{
    			color: #4DB4F4;
    		}
    		>>>.el-checkbox__label{
    			color: #439fe3 !important;
    		}
    	}
    }
}
</style>



// WEBPACK FOOTER //
// src/views/SpecialExamTest/specialExamTestDefault/index.vue